import {
  Button,
  CircularProgress,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Fragment, useContext, useEffect, useState } from "react";
import { ComplaintContext } from ".";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { ComplaintsDropdownType, ComplaintsType } from "./types";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddComplaints from "./AddComplaints";
import { useMutation } from "react-query";
import { deleteComplaints, getComplaints } from "../../services";
import { useParams } from "react-router-dom";
import usePopup from "../../../hooks/usePopup";
// import LogComonent from "../layouts/LogComonent";
import { HL7ContexTriggerContex } from "../../../context/HL7MessageTrigger/HL7MessageTriggerProvider";
import Close from "@mui/icons-material/Close";
import EmptyListAlert from "../layouts/EmptyListAlert";
import HistoryComponent from "../layouts/HistoryComponent";

function ComplaintsList() {
  const { encounterId } = useParams();
  const {setTrigger} = useContext(HL7ContexTriggerContex)
  const { showSnackbar } = usePopup();
  const [show, setShow] = useState<boolean>(false);
  const [selected,setSelected] = useState(-1)
  const { list, edit, setEdit, setList } = useContext(ComplaintContext);
  const { mutate: fetchComplaints } = useMutation(getComplaints, {
    onSuccess: (result) => {
      setList([...result.response]);
    },
  });
  const { mutate: removeComplaints, isLoading: deleteLoading } = useMutation(
    deleteComplaints,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success"){
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "success",
            duration: 2000,
          });
          setTrigger({
            encounterId:encounterId as string,
            tab:'complaints'
          })
          fetchComplaints(encounterId as string);
        } else {
          showSnackbar({
            message: result.response,
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
      onError:()=>{
        showSnackbar({
          message: "Something went wrong",
          open: true,
          variant: "warning",
          duration: 2000,
        });
      }
    }
  );
  const handleEdit = (complaint: ComplaintsType) => {
    setEdit(complaint);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleCloseCollapse = ()=>{
    setEdit(null)
  }

  const handleDelete = (id: number,index:number) => {
    setSelected(index)
    removeComplaints(id);
  };

  useEffect(() => {
    fetchComplaints(encounterId as string);
  }, []);
  return (
    <div>
      <TableContainer className="border rounded relative">
        <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow
              sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
            >
              {heading.map((head: string, index: number) => (
                <TableCell
                  key={`tableheading${index}`}
                  sx={(theme) => ({ color: theme.palette.background.paper })}
                >
                  {head}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell colSpan={heading.length}>
              <EmptyListAlert alert="No complaints" isData={Boolean((list.length || show))}>
                  <>
                  {!show && (
                  <div className="flex justify-end items-center gap-2">
                    <Button
                      onClick={() => {
                        setShow(true);
                        setEdit(null)
                      }}
                      color="success"
                      endIcon={<AddCircleIcon />}
                    >
                      add
                    </Button>
                    {/* <LogComonent /> */}
                    <HistoryComponent logProps={{field:"complaints",title:"Complaints" }} title="Complaints"  tableprops={tableProps}/>
                  </div>
                )}
                  </>
              </EmptyListAlert>
                <Collapse in={show}>
                  <AddComplaints close={handleClose} />
                </Collapse>
              </TableCell>
            </TableRow>
            {list.map((row, index: number) => (
              <Fragment key={`complaintTable${index}`}>
                <TableRow
                  key={`${(row?.complaints as ComplaintsDropdownType).comId}${index}`}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>
                    {(row?.complaints as ComplaintsDropdownType).comName}
                  </TableCell>
                  <TableCell>{row.duration}</TableCell>
                  <TableCell>{row.quality}</TableCell>
                  <TableCell>{row.severity}</TableCell>
                  {/* <TableCell>{row.date as string}</TableCell> */}
                  <TableCell>
                    {row.emrComplaintId == edit?.emrComplaintId ? <IconButton onClick={handleCloseCollapse} color="error">
                          <Close />
                        </IconButton> : <IconButton
                      color="primary"
                      onClick={() => {
                        handleEdit(row);
                        setShow(false)
                      }}
                    >
                      <EditIcon />
                    </IconButton>}
                    {(deleteLoading && selected == index) ? <CircularProgress size={18} color="error"/> : <IconButton
                      color="error"
                      onClick={() => {
                        handleDelete(row.emrComplaintId,index);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                    <Collapse
                      in={
                        Boolean(edit) &&
                        row.emrComplaintId == edit?.emrComplaintId
                      }
                    >
                      <AddComplaints close={handleClose} />
                    </Collapse>
                  </TableCell>
                </TableRow>
              </Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default ComplaintsList;
const heading = [
  "CHIEF COMPLAINTS",
  "DURATION",
  "QUALITY",
  "SEVERITY",
  // "DATE",
  "OPTIONS",
];
const tableProps=[

     { heading: "CHIEF COMPLAINTS", key: "complaints.comName" },
      { heading: "DURATION", key: "duration" },
      { heading: "QUALITY", key: "quality" },
      { heading: "SEVERITY", key: "severity" },
  
]
